import styled from "styled-components";

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const GridRow = styled.div`
  display: flex;
  border-bottom: 1px solid #ced4da;
  padding-left: 10px;
`;

export const GridColumn = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 10px 20px 0px;

  color: #495057;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const GridHeaders = styled.div`
  display: flex;
  width: 100%;
  background-color: #f5f7fa;
  padding: 20px 10px;
  border-bottom: 1px solid #ced4da;
`;

export const GridHeader = styled.div`
  display: flex;
  width: 100%;
  padding-right: 10px;
  font-weight: bold;
  line-height: normal;
  text-transform: uppercase;
`;
